import { useEffect, useRef, useState } from "react";

export const useWelcomeBonusAvailableTimer = (secondsLeft = 0) => {
    const timer = useRef(null);
    const [secondsLeftForFullBonus, setSecondsLeftForFullBonus] = useState(0);
    useEffect(() => {
        setSecondsLeftForFullBonus(secondsLeft);
    }, [secondsLeft])

    useEffect(() => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        if (secondsLeftForFullBonus > 0) {
            timer.current = setTimeout(() => setSecondsLeftForFullBonus(currentSeconds => currentSeconds - 1), 1000);
        }
    }, [secondsLeftForFullBonus])

    return {secondsLeftForFullBonus};
}
